import { Show } from "solid-js";
import { Panel } from "../layout/Panel.tsx";
import { MetricCard } from "../viz/MetricCard.tsx";
import { metrics } from "../../stores/metrics.ts";

const STATUS_LABELS: Record<number, string> = { 0: "Green", 1: "Yellow", 2: "Red" };
const STATUS_COLORS: Record<number, string> = {
  0: "var(--color-healthy)",
  1: "var(--color-warning)",
  2: "var(--color-critical)",
};

/**
 * Infrastructure panel — Elasticsearch + Redis + Host metrics from NR.
 * Sources: ElasticsearchClusterSample, RedisSample, SystemSample.
 */
export function InfraPanel() {
  const get = (m: string) => metrics.latest[`newrelic-infra:${m}`]?.value;

  return (
    <Panel title="Infra · ES / Redis / Host" span="col-span-4">
      <div class="space-y-3">
        {/* Elasticsearch cluster */}
        <div>
          <div class="mb-1.5 font-mono text-[9px] uppercase tracking-widest text-[var(--color-text-dim)]">
            Elasticsearch
          </div>
          <div class="grid grid-cols-3 gap-2">
            <div class="metric-inset px-3 py-2">
              <div class="font-mono text-[9px] uppercase tracking-wider text-[var(--color-text-dim)]">
                Status
              </div>
              <Show
                when={get("es_status") !== undefined}
                fallback={<div class="font-mono text-sm text-[var(--color-text-dim)]">—</div>}
              >
                <div
                  class="font-mono text-sm font-bold"
                  style={{ color: STATUS_COLORS[get("es_status")!] ?? "var(--color-text-secondary)" }}
                >
                  {STATUS_LABELS[get("es_status")!] ?? "?"}
                </div>
              </Show>
            </div>
            <MetricCard label="Nodes" value={get("es_nodes")} digits={0} />
            <MetricCard label="Shards" value={get("es_active_shards")} digits={0} />
          </div>
        </div>

        {/* Redis */}
        <div>
          <div class="mb-1.5 font-mono text-[9px] uppercase tracking-widest text-[var(--color-text-dim)]">
            Redis
          </div>
          <div class="grid grid-cols-3 gap-2">
            <MetricCard label="Clients" value={get("redis_clients")} digits={0} />
            <MetricCard label="Memory" value={get("redis_memory_mb")} unit="MB" digits={1} />
            <MetricCard label="Cmd/sec" value={get("redis_cmds_per_sec")} digits={1} />
          </div>
        </div>

        {/* Host system */}
        <div>
          <div class="mb-1.5 font-mono text-[9px] uppercase tracking-widest text-[var(--color-text-dim)]">
            Host
          </div>
          <div class="grid grid-cols-2 gap-2">
            <MetricCard label="CPU" value={get("host_cpu_pct")} unit="%" digits={1} />
            <MetricCard label="Memory" value={get("host_memory_pct")} unit="%" digits={1} />
          </div>
        </div>
      </div>
    </Panel>
  );
}
